import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';

import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Center,
  IconButton,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { PageWrapper, Text } from '../../../components';
import {
  cockpitGet,
  getCockpitAssetUrl,
} from '../../../config/cockpit';
import { TextType } from '../../../models/Text';

interface CockpitAsset {
  path?: string;
}

interface GlobalData {
  heroVideo?: CockpitAsset;
}

const Intro = () => {
  const { t } = useTranslation();

  const [heroVideo, setHeroVideo] =
    useState<string>('');

  const height = useMemo<number>(
    () => window.innerHeight,
    []
  );

  useEffect(() => {
    cockpitGet<GlobalData>(
      '/api/content/item/Global'
    )
      .then((data) => {
        if (data.heroVideo?.path) {
          setHeroVideo(
            getCockpitAssetUrl(
              data.heroVideo.path
            )
          );
        }
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.error(
          'Failed to load hero video from Cockpit:',
          err
        );
      });
  }, []);

  const handleScrollDown = () => {
    const element =
      document.getElementById('expertise');

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <PageWrapper>
      <Box
        position="relative"
        width="100%"
        height={height}
        overflow="hidden"
      >
        {heroVideo ? (
          <video
            src={heroVideo}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        ) : (
          <Box
            width="100%"
            height="100%"
            bgColor="black"
          />
        )}

        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
          bgColor="rgba(0,0,0,0.4)"
          pointerEvents="none"
        />

        <Box
          position="absolute"
          bottom={0}
          left="10%"
          right={0}
          top={0}
          w="80%"
        >
          <Center
            flexDirection="column"
            alignItems="center"
            height="100%"
            w="75%"
          >
            <Text
              type={TextType.Inter20Regular}
              color="white"
            >
              {t('homepage.welcome')}
            </Text>
          </Center>
        </Box>

        <Center
          position="absolute"
          bottom={0}
          width="100%"
        >
          <IconButton
            variant="link"
            aria-label="Scroll down to see the content"
            icon={
              <ChevronDownIcon boxSize={50} />
            }
            color="white"
            size="md"
            marginBottom="40px"
            onClick={handleScrollDown}
          />
        </Center>
      </Box>
    </PageWrapper>
  );
};

export default Intro;